import React, { Component } from 'react';
import Logo from '../../_assets/images/logo@2x.png';
import queryString from 'query-string';
import axiosInstance from '../../_helpers/axiosConfig'
import getApiVersion from '../../_helpers/api-version';

import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { userActions } from '../../_actions/user.actions';
import { alertActions } from '../../_actions/alert.actions';
import { clientService } from '../../_services/client.service';
import { clientActions } from '../../_actions/client.actions';
import { authenticationActions } from '../../_actions/authentication.actions';

class Refresh extends Component {
  constructor(props) {
    super(props)

    if (!props.history.location.search) {
      props.history.push('/login');
    }

    const queryParams = queryString.parse(props.history.location.search);

    if (!('auth' in queryParams) || !('clientId' in queryParams)) {
      props.history.push('/login');
    }

    this.auth = queryParams.auth;
    this.clientId = queryParams.clientId;
  }

  componentDidMount() {
    this.props.dispatch(authenticationActions.setToken(this.auth));

    clientService.getInfo(this.auth, this.clientId)
      .then(data => {
        this.props.dispatch(clientActions.setAccount(data.client));
      })
      .then(() => {
        return axiosInstance.request({
          url: `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/me`,
          method: 'GET',
          headers: { 'Authorization': `Bearer ${this.auth}` }
        })
        .then(response => {
          this.props.dispatch(userActions.setCurrentUser(response.data));
          this.props.dispatch(authenticationActions.setPermissions(response.data.permissions));
        })
      })
      .then(() => {
        this.props.history.push('/');
      })
      .catch(() => {
        this.props.history.push('/login');
        this.props.dispatch(alertActions.error('Sorry for the inconvenience, but please log in again.'))
      });
  }

  render() {
    return (
      <div className="row h-100">
        <div className="col-lg-10 offset-lg-1 my-auto">
          <div className="card axs-shadow container">
            <div className="card-body">
              <div className="row" style={{ height: '20em' }}>
                <div className="col-lg-4 d-flex p-5" style={{ backgroundColor: '#1AB2E9' }}>
                  <img src={Logo} alt="AxS Logo" className="m-auto img-fluid" />
                </div>
                <div className="col-lg-8 p-5 m-auto text-center">
                  <Spinner animation="border" role="status" />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <small>v{process.env.REACT_APP_API_VERSION} (Build {process.env.REACT_APP_BUILD})</small>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Refresh);